// import * as Sentry from '@sentry/browser';
import supportedBrowserNotification from './supported-browser-notification';

// Sentry.init({
//     dsn: 'https://2d0047a53f9749d4806e3d46afcdbf89@sentry.io/1770244',
//     sampleRate: 0.25,
//     whitelistUrls: [
//         'www.stellantisandyou.co.uk'
//     ]
// });

const validBrowser = supportedBrowserNotification();

window.$ = window.jQuery = require('jquery');
require('../modernizr-webp.js');
// require('../jasny/jasny-bootstrap.js');
import { headroom } from '../header-menu.js';
window.headroom = headroom;
require('bootstrap-sass');
// require('../safari-fix.js');
window.Cookies = require('js-cookie');
require('remodal');
require('../modules/remodal/mobile-fix');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// Dealer data for maps
// import { locationData } from '../modules/json/locationData';
// window.locationData = locationData;
import LocationDataLoader from '../modules/LocationDataLoader';
window.LocationDataLoader = new LocationDataLoader;

// Finance globals
import { annualMileages } from '../modules/json/annualMileages';
window.annualMileages = annualMileages;
import { financeKeys } from '../modules/json/financeKeys';
window.financeKeys = financeKeys;
import { financeNames } from '../modules/json/financeNames';
window.financeNames = financeNames;

require('slick-carousel');

// Global instance to the empty remodal in the footer of every page. Useful for loading in forms via AJAX
window.inst = $('[data-remodal-id=modal]').remodal({ hashTracking: false });

require('../general-functions');

import ContactFormValidator from '../validation/ContactFormValidator';
import CustomerLocationHandler from '../modules/CustomerLocationHandler';
import LiveChatClass from '../live-chat/modules/live-chat-class';
import GoogleMapsLoaderClass from '../modules/GoogleMapsLoader';
// Global function to get the correct map pin icon depending on brand
import getMapIcon from '../modules/mapIcon';
import togglePersonalQuoteTerms from './modules/toggle-personal-quote-terms';
import setupMobileMenu from '../mega-menu/mobile';
import setupHeaderMenuTouchEvents from '../mega-menu/touch';
import setupAnalyticsClickEventsViaDataAttributes from './../analytics/track-by-data-attributes';
import initializeMegaMenu from '../mega-menu';

if (validBrowser) {
    initializeMegaMenu();
    setupMobileMenu();
    setupHeaderMenuTouchEvents();
    window.ContactFormValidator = ContactFormValidator;
    window.CustomerLocationHandler = CustomerLocationHandler;
    if (typeof liveChatDisabled == 'undefined' || liveChatDisabled === false) {
        console.log('Initializing Live Chat');
        window.liveChatClass = new LiveChatClass;
        setTimeout(() => {
            liveChatClass.initLiveChat((typeof liveChatLocationId !== 'undefined') ? liveChatLocationId : false);
        }, 500);
    }
    // Create a global object for getting a new Google Maps instance
    window.GoogleMapsLoader = new GoogleMapsLoaderClass;
    // Handle detecting when Google Maps has finished loading
    window.googleMapsLoaded = () => { GoogleMapsLoader.mapLoaded(); };
    window.getMapIcon = getMapIcon;

    setupAnalyticsClickEventsViaDataAttributes();
    require('../cookie-warning.js');
    togglePersonalQuoteTerms();
}